import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface ICompanyData {
  id: number;
  name: string;
  user_count?: number;
  [key: string]: unknown;
}

const initialState = {
  companyData: [] as ICompanyData[],
};

export const companySlice = createSlice({
  name: "companySlice",
  initialState,
  reducers: {
    setCompanyData: (state, action: PayloadAction<ICompanyData[]>) => {
      state.companyData = action.payload;
    },
  },
});

export const { setCompanyData } = companySlice.actions;

export default companySlice.reducer;
